// frontend/src/api.js
import axios from 'axios';


const base = process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim() !== ''
  ? process.env.REACT_APP_API_URL.replace(/\/$/, '')
  : ''; // Default to empty string for relative paths in production

export const ApiBaseUrl = base ? `${base}/api` : '/api';

const api = axios.create({
  baseURL: ApiBaseUrl,
  timeout: 30000,
});


export default api;

export const listInbound = async (limit = 100) => {
  const { data } = await api.get(`/inbound?limit=${limit}`);
  return data.items || [];
};

export const sendReply = async ({ toPhone, messageText, senderPhoneId }) => {
  const { data } = await api.post('/inbound/reply', { toPhone, messageText, senderPhoneId });
  return data;
};

export const deleteContact = async (id) => {
  const { data } = await api.delete(`/contacts/delete/${id}`);
  return data;
};

export const updateContact = async (id, payload) => {
  const { data } = await api.put(`/contacts/update/${id}`, payload);
  return data;
};
